import debug from 'debug';

/**
 * Namespaced logger, matching the `data:analytics` / `data:client` convention.
 * Enable in a browser with `localStorage.debug = 'data:rum'`.
 *
 * `no-console` is enforced repo-wide and `.jest/fail-on-console.js` fails tests
 * on stray output, so nothing in this library may log directly.
 */
export const log = debug('data:rum');
